// Locale/currency helpers shared by the inboedel and woonhuis calc chains. Only the
// byte-identical parts live here; formatCurrency intentionally stays per-product because the
// two implementations diverge (see the comment above each formatCurrency in
// inboedel/calc.ts and woonhuis/calc.ts).

/**
 * Get the current locale from localStorage
 */
export const getCurrentLocale = (): string => {
  if (typeof window !== 'undefined' && window.localStorage) {
    const lang = localStorage.getItem('sluitstraat-language') || 'nl';
    return lang === 'en' ? 'en-GB' : 'nl-NL';
  }
  return 'nl-NL';
};

/**
 * Remove formatting from currency
 */
export const unformatCurrency = (value: string): number | null => {
  if (!value) return null;
  const cleaned = value.replace(/\D/g, '');
  return cleaned ? Number(cleaned) : null;
};
